const testimonialsData = {
  en: [
    {
      quote: "Assemblage transformed our vision into a celebration that exceeded our wildest dreams. Every detail was perfect.",
      author: "Sarah & James",
      location: "New York",
      photo: "/images/beachkiss.jpg"
    },
    {
      quote: "The team's attention to detail and local expertise made our destination wedding seamless and magical.",
      author: "Maria & Carlos",
      location: "Mexico City",
      photo: "/images/flowers2.jpg"
    },
    {
      quote: "We felt truly cared for from start to finish. Our guests are still talking about the experience!",
      author: "Emily & Daniel",
      location: "London",
      photo: "/images/tulum.jpg"
    }
  ],
  es: [
    {
      quote: "Assemblage hizo realidad nuestra visión y superó todas nuestras expectativas. Cada detalle fue perfecto.",
      author: "Ana & Luis",
      location: "CDMX",
      photo: "/images/beachkiss.jpg"
    },
    {
      quote: "El equipo cuidó cada detalle y su experiencia local hizo nuestra boda de destino mágica y sin estrés.",
      author: "María & Carlos",
      location: "Guadalajara",
      photo: "/images/flowers2.jpg"
    },
    {
      quote: "Nos sentimos acompañados de principio a fin. ¡Nuestros invitados siguen hablando de la experiencia!",
      author: "Lucía & Daniel",
      location: "Madrid",
      photo: "/images/tulum.jpg"
    }
  ]
};

export default testimonialsData; 